export default "__VITE_ASSET__beedc098__"